module.exports = __webpack_public_path__ + "static/fonts/Mont-LightItalic.905e369.woff";